import Entity from '../entity'

export default class FavoriteItem extends Entity<number>{
    productId: number  = null;
    productNo: string;
    productName: string  = null;
    productImageUrl: string  = null;
    unitPrice: string  = null;
    wxUserId: number  = null;
    userId: number  = null;
    userNo: string;
    isMovedToShoppingCart: boolean;
    tenantId: number  = null;
    wxAppUserId: number  = null;
    remark: string  = null;
    userName: string  = null;
}